"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LetterSpacing = void 0;
exports.LetterSpacing = {
    "kerning-none": 0,
    "kerning-1": 0.15,
    "kerning-2": 0.25,
    "kerning-3": 0.5,
    "kerning-4": 1.25
};
//# sourceMappingURL=LetterSpacing.js.map